import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.SomethingElsePropertyPopUp.title',
    defaultMessage: "Unfortunately, we can't assist you online",
  },
  requireText: {
    id: 'src.pages.SomethingElsePropertyPopUp.requireText',
    defaultMessage: 'We require a bit more information to make sure we help you in the right way.',
  },
  callUs: {
    id: 'src.pages.SomethingElsePropertyPopUp.callUs',
    defaultMessage: 'Please call us at ',
  },
  callUsTwo: {
    id: 'src.pages.SomethingElsePropertyPopUp.callUsTwo',
    defaultMessage: ' to speak to one of our Claims team members.',
  },
  close: {
    id: 'src.pages.SomethingElsePropertyPopUp.close',
    defaultMessage: 'Back to Dashboard',
  },
});
